// extracted by mini-css-extract-plugin
module.exports = {"moreModalOverlay":"MoreMobileModal_moreModalOverlay__3EZOI","moreModal":"MoreMobileModal_moreModal__3FjJL"};